'use strict'

import $ from 'jquery';

let dom = {};

const searchPane = {
  searchTimer: null,
  searchXhr: null,
  lastSearchText: null,
  searchPaneVisible: false,
  toggleSearchPane(){
    if(!this.searchPaneVisible){
      dom.$searchPane.removeClass('d-none').attr('aria-hidden','false');
      setTimeout(function(){
        dom.$searchField.focus();
      }, 100)
    } else {
      dom.$searchPane.addClass('d-none').attr('aria-hidden','true');
      dom.$togglers.get(0).focus();
    }
    this.searchPaneVisible = !this.searchPaneVisible;
  },

  doSearch(){
    const self = this;
    const searchText = dom.$searchField.val().trim();
    clearTimeout(self.searchTimer);

    if(!searchText || searchText === self.lastSearchText){
      return;
    }
    if(self.searchXhr){
      // Abort active ajax request
      self.searchXhr.abort();
    }

    // Hide results
    dom.$results.addClass('d-none');
    // Show loader animation
    dom.$loading.removeClass('d-none').attr('aria-hidden','false');

    // Delayed ajax
    self.searchTimer = setTimeout(function(){
      // Do ajax request
      self.searchXhr = $.get({
        url: '/stage-ajax/' + dom.$body.data('year') + '-search-pane/',
        data: {
          'stage-language': $('html').attr('lang'),
          'search': searchText
        },
        dataType: 'html',
      }).done(function(response){
        self.lastSearchText = searchText;
        dom.$results.html(response).removeClass('d-none').attr('aria-hidden','false');
      }).fail(function(jqXHR, textStatus, errorThrown){
        dom.$results.html(textStatus).removeClass('d-none').attr('aria-hidden','false');
      }).always(function(){
        dom.$loading.addClass('d-none').attr('aria-hidden','true');
      });
    }, 500);
  },

  init(){
    const self = this;
    dom.$body = $('body');
    dom.$togglers = $('[data-toggle="search-pane"]');
    dom.$searchPane = $('.search-pane');
    dom.$searchField = dom.$searchPane.find('.search-pane__search-field');
    dom.$searchButton = dom.$searchPane.find('.search-pane__search-button');
    dom.$searchResultsPane = $('.search-pane__results-pane');
    dom.$searchResults = dom.$searchResultsPane.find('.search-pane__results');
    dom.$loading = dom.$searchPane.find('.search-pane__loading');
    dom.$results = dom.$searchPane.find('.search-pane__results');

    // Add event listeners

    // Body click > hide search
    $('body').on('click', function(evt){
      if(self.searchPaneVisible && !$(evt.target).closest('.search-pane').length){
        self.toggleSearchPane();
      }
    });
    // Esc key > hide search
    $(document).on('keydown', function(evt){
      if(self.searchPaneVisible && evt.keyCode === 27){
        evt.stopPropagation();
        self.toggleSearchPane();
      }
    });
    // Togglers > Show/hide search
    dom.$togglers.on('click', function(evt){
      evt.stopPropagation();
      self.toggleSearchPane();
    });
    // Search field enter key > do search
    dom.$searchField.on('keydown', function(evt){
      if(evt.keyCode === 13){
        evt.preventDefault();
        evt.stopPropagation();
        // Enter key
        self.doSearch();
      }
    });
    // Search button click
    dom.$searchButton.on('click', function(evt){
      evt.preventDefault();
      self.doSearch();
    });
  }
}

module.exports = searchPane;
